import React from 'react';
import { registerRootComponent } from 'expo';
import App from './App';

// Initialize Sentry before app renders so render errors are captured.
import { initSentry } from './sentry';
initSentry();

// Gated Cloud Functions need the user's ID token (utils/authFetch.js).
import { auth } from './firebaseConfig';
import { installAuthFetch } from './utils/authFetch';
installAuthFetch(auth);

// In development, Expo's registerRootComponent wraps the app in <React.StrictMode>,
// which double-invokes all useEffect hooks. Firestore SDK v12+ internally uses
// snapshot listeners for getDoc(), so concurrent calls to the same document path
// (from the double-invoke) collide on Target IDs → "Target ID already exists" errors.
// Replace StrictMode with Fragment (a transparent no-op) to eliminate this entirely.
// Production is unaffected — registerRootComponent never adds StrictMode there.
if (process.env.NODE_ENV === 'development') {
  React.StrictMode = React.Fragment;
}

registerRootComponent(App);
